import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { CategoriesListCard } from './components/CategoriesListCard';
import { CustomDrinkDeleteCard } from './components/CustomDrinkDeleteCard';
import { CustomDrinkDetailsCard } from './components/CustomDrinkDetailsCard';
import { RecipeItemListCard } from './components/RecipeItemListCard';

export function CustomDrinkDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const customDrinkQueryResults = useQuery({
        queryKey: ['customDrink', id],
        queryFn: () => Api.CustomDrinks.CustomDrink.getCustomDrink(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="lg" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={customDrinkQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <CustomDrinkDetailsCard customDrink={data} />

                            <RecipeItemListCard
                                customDrink={data}
                                refetch={customDrinkQueryResults.refetch}
                            />
                            <CategoriesListCard
                                customDrink={data}
                                refetch={customDrinkQueryResults.refetch}
                            />

                            {!data?.categories?.length && (
                                <Can I="delete" a="Product">
                                    <CustomDrinkDeleteCard customDrink={data} />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
